import { render } from "./CarrierRate.vue?vue&type=template&id=6560e96a"
import script from "./CarrierRate.vue?vue&type=script&lang=js"
export * from "./CarrierRate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__